<template>
<div class="page-wrapper">
	<div class="page page-profile" v-if="user">
		<div class="container">
			<div class="row">
				<div class="col-md-4 col-lg-3">
					<div class="profile box pl-0 pr-0 pb-0">
						<div class="profile-picture" :class="[{ 'is-loading': isUploading }]">
							<input type="file" accept="image/*" class="input-file" id="profile-picture-file" @change="onImageChange">
							<label :for="`profile-picture-file`" class="profile-picture-upload" :class="[{ 'active': userEdit.picture === '' }]">
								<div class="profile-picture-upload-button" v-if="userEdit.picture === ''">
									<i class="icon material-icons">camera_alt</i>
								</div>
								<img :src="imageDisplay" class="profile-picture-image" v-if="userEdit.picture !== ''">
								<i class="icon material-icons" v-tooltip="$t('Change Profile Picture')" v-if="userEdit.picture !== ''">camera_alt</i>
							</label>
						</div>
						<div class="profile__greetings text-center mb-3">
							Hi, <b>{{ user.name }}</b>
						</div>
						<div
							class="billing-plan-wrapper px-3 pb-3"
							v-if="isOwner">
							<div class="billing-plan card border-0 shadow-sm p-3" style="border-radius: 12px; background: #f8f9fa;">
								<div class="font-weight-bold text-dark mb-3" style="font-size: 15px;">
									Status Langganan
								</div>
								<div class="mb-3">
									<div class="d-flex justify-content-between align-items-center">
										<span class="text-muted small">Status:</span>
										<span class="badge px-3 py-2 font-weight-bold" :class="isExpired ? 'badge-danger' : 'badge-success'">
											{{ isExpired ? 'Expired' : 'Aktif' }}
										</span>
									</div>
								</div>
								<div class="mb-2 d-flex justify-content-between">
									<span class="text-muted small">Mulai:</span>
									<span class="text-dark font-weight-bold small">{{ subscriptionStartDate }}</span>
								</div>
								<div class="mb-3 d-flex justify-content-between">
									<span class="text-muted small">Berakhir:</span>
									<span class="text-dark font-weight-bold small">{{ subscriptionEndDate }}</span>
								</div>
								<router-link to="/billings" class="btn btn-primary btn-block font-weight-bold mt-2" style="border-radius: 8px;">
									Kelola Tagihan
								</router-link>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-8 col-lg-9">
					<div class="profile box pt-0 px-0">
						<div class="tab-items border-bottom">
							<!-- <div
								class="tab-item cur-p"
								:class="{ 'active': tab === 'plan' }"
								@click="setTab('plan')"
								v-if="isOwner">
								Billing Plan
							</div> -->
							<div
								class="tab-item cur-p"
								:class="{ 'active': tab === 'profile' }"
								@click="setTab('profile')">
								{{ $t('Edit Profile') }}
							</div>
							<div
								class="tab-item cur-p"
								:class="{ 'active': tab === 'devices' }"
								@click="setTab('devices')">
								{{ $t('Devices') }}
							</div>
							<div
								class="tab-item cur-p"
								:class="{ 'active': tab === 'bank' }"
								@click="setTab('bank')"
								v-if="isSupplier">
								{{ $t('Bank Accounts') }}
							</div>
							<div
								class="tab-item cur-p"
								:class="{ 'active': tab === 'address' }"
								@click="setTab('address')"
								v-if="isDropshipper">
								{{ $t('Address') }}
							</div>
						</div>
						<div class="tab-contents px-4 py-3">
							<!-- Edit Profile -->
							<div
								class="tab-content"
								v-if="tab === 'profile'">
								<div class="profile__edit p-0">
									<!-- <div class="profile__edit__title">My Profile</div> -->
									<div class="profile__fields">
										<div class="profile-field form-group">
											<label for="profile-name"><b>{{ $t('_.fullname') }}</b></label>
											<input type="text" class="input form-control" :class="{ 'error': isNameError }" id="profile-name" placeholder="Your Name" @input="onNameChange" v-model="userEdit.name">
										</div>
										<div class="profile-field form-group" v-if="isOwner">
											<label for="profile-username"><b>Username</b></label>
											<input type="text" class="input form-control" maxlength="50" :class="{ 'error': isUsernameError }" id="profile-username" placeholder="Your Username" @input="onUsernameChange" v-model="userEdit.username">
											<!-- <div class="field-info">https://<b>{{userEdit.username}}</b>.ostock.id</div> -->
											<div class="field-error" v-if="isUsernameError">{{ $t('Sorry, username is not available') }}</div>
										</div>
										<div class="profile-field form-group">
											<label for="profile-email"><b>Email</b> {{ $t('profile.emailInfo') }}</label>
											<input readonly type="email" class="input form-control" id="profile-email" placeholder="Your Email Address" :value="userEdit.email">
										</div>
										<div class="profile-field form-group">
											<button
												type="button"
												class="btn btn-light btn-block m-0"
												:disabled="isHasFeature(user, 'official_seller')"
												@click="showModalChangeEmail">
												<i class="material-icons">edit</i><span>{{ $t('profile.changeEmail') }}</span>
											</button>
										</div>
										<div class="profile-field form-group" v-if="isOwner">
											<label for="profile-phone"><b>{{ $t('_.phoneNumber') }}</b></label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">{{ countryCode }}</span>
												</div>
												<input
													id="profile-phone"
													type="tel"
													class="input form-control"
													placeholder=""
													:value="userEdit.phone"
													readonly
												>
											</div>
										</div>
										<div class="profile-field form-group">
											<button
												type="button"
												class="btn btn-light btn-block m-0"
												@click="showModalChangePhoneNumber">
												<i class="material-icons">edit</i><span>{{ $t('profile.changePhoneNumber') }}</span>
											</button>
										</div>
										<!-- Language -->
										<div class="profile-field form-group" v-if="isAdmin">
											<label for="profile-locale"><b>{{ $t('_.language') }}</b></label>
											<select class="form-control" id="profile-locale" v-model="userEdit.locale">
												<option value="en">English</option>
												<option value="id">Bahasa Indonesia</option>
											</select>
										</div>
										<div class="profile-field form-group mt-4 mb-4">
											<button
												type="button"
												class="btn btn-light btn-block"
												@click="isShowChangePassword = true">
												<i class="material-icons mr-2">lock_open</i>
												<span>{{ $t('profile.changePassword') }}</span>
											</button>
										</div>
										<div class="profile-field form-group">
											<button
												type="button"
												class="btn btn-primary btn-block m-0"
												:class="[{ 'is-loading': isSaving }]"
												:disabled="isHasError"
												@click="saveProfile">
												{{ $t('profile.saveProfile') }}
											</button>
										</div>
									</div>
								</div>
							</div>
							<!-- Billing Plan -->
							<div
								class="tab-content"
								v-if="tab === 'plan'">
								<div
									class="billing-plan-wrapper ml-0 mt-3"
									v-if="isOwner">
									<div class="billing-plan">
										<div class="billing-plan__name">{{ $t('Your Current Plan') }}</div>
										<div class="billing-plan__section text-center">
											<div class="billing-plan__price text-capitalize">{{ user.package }}</div>
											<div class="billing-plan__expire">{{ $t('Active Until') }}: <b>{{ expiredDate }}</b></div>
										</div>
										<div class="billing-plan__section">
											<p class="text-center">{{ $t('Your Credits') }}:</p>
											<div class="billing-plan-features">
												<div class="billing-plan-feature align-items-center">
													<svg class="feather mr-3 text-primary">
														<use xlink:href="/icons/feather-sprite.svg#package"/>
													</svg>
													<span><b>{{ productLimit }}</b> {{ $t('Products') }}</span>
												</div>
												<div class="billing-plan-feature align-items-center">
													<svg class="feather mr-3 text-primary">
														<use xlink:href="/icons/feather-sprite.svg#shopping-bag"/>
													</svg>
													<span><b>{{ orderLimit }}</b> {{ $t('Orders') }}</span>
												</div>
												<div class="billing-plan-feature align-items-center">
													<svg class="feather mr-3 text-primary">
														<use xlink:href="/icons/feather-sprite.svg#users"/>
													</svg>
													<span><b>{{ teamMemberLimit }}</b> {{ $t('Team Member') }}</span>
												</div>
											</div>
										</div>
										<div class="billing-plan__section">
											<router-link to="/plans" class="btn btn-lg btn-block btn-primary btn-select-plan">{{ $t('Upgrade Plan') }}</router-link>
										</div>
									</div>
								</div>
							</div>
							<!-- Devices -->
							<div
								class="tab-content"
								v-if="tab === 'devices'">
								<div class="login-devices list-group mt-3">
									<div class="list-group-item py-3 bg-grey-dark text-bold">{{ $t("Where You're Logged In") }}</div>
									<template v-if="!isFetchingDevices">
										<user-device
											v-for="device in devices"
											:key="device._id"
											:data="device"
											@remove="confirmRemove">
										</user-device>
									</template>
									<div class="list-group-item text-center" v-else>
										<div class="is-loading dark"></div>
									</div>
								</div>
							</div>
							<!-- Bank Accounts -->
							<div
								class="tab-content"
								v-if="tab === 'bank'">
								<div class="integration-item box p-0">
									<div class="integration-app">
										<div class="wrapper">
											<div class="integration-app-logo">
												<div class="text">{{ $t('Bank Accounts') }}</div>
											</div>
											<button type="button" class="integration-app-button btn btn-primary" @click="isShowAddBank = true">+ <span class="ml-2">{{ $t('Add Bank Account') }}</span></button>
										</div>
									</div>
									<bank-accounts :accounts="bankAccounts"></bank-accounts>
								</div>
							</div>
							<!-- Address -->
							<div
								class="tab-content"
								v-if="tab === 'address'">
								<div class="row">
									<div class="col-md-4">
										<store-address />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="is-loading large mt-5" v-if="!user"></div>

	<div class="modals">
		<!-- Change Password -->
		<modal
			class="change-password-modal"
			@close="isShowChangePassword = false"
			v-if="isShowChangePassword">
			<div slot="header">
				<h3><i class="material-icons">lock</i><span class="text">{{ $t('Change Password') }}</span></h3>
			</div>
			<div slot="body">
				<div class="">
					<div class="form-group" v-if="!hideCurrentPasswordForm">
						<label><b>{{ $t('Current Password') }}</b></label>
						<input type="password" class="form-control" placeholder="Please enter your password" v-model="currentPassword">
					</div>
					<div class="form-group">
						<label><b>{{ $t('New Password') }}</b></label>
						<input type="password" class="form-control" placeholder="Your new password" v-model="newPassword" @input="onNewPasswordChange">
						<div class="field-error" v-if="!isNewPasswordValid">{{ $t('Password is minimal 6 character') }}</div>
					</div>
					<div class="form-group">
						<label><b>{{ $t('Confirm New Password') }}</b></label>
						<input type="password" class="form-control" placeholder="Re-enter your new password" :class="{ 'error': !isNewPasswordMatch }" v-model="newPasswordConfirmation">
						<div class="field-error" v-if="!isNewPasswordMatch">{{ $t('New Password not match') }}</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowChangePassword = false">{{ $t('Close') }}</button>
				<button type="button" class="btn btn-primary" :class="{ 'is-loading': isChangingPassword }" :disabled="!isCanChangePassword" @click="changePassword">{{ $t('Change Password') }}</button>
			</div>
		</modal>

		<!-- Logout Device -->
		<modal
			class=""
			@close="isRemoveDeviceVisible = false"
			v-if="isRemoveDeviceVisible">
			<div slot="header">
				<h3>{{ $t('Remove Device') }}</h3>
			</div>
			<template slot="body">
				{{ $t('Logout the selected device?') }}
			</template>
			<div slot="footer">
				<button
					type="button"
					class="btn btn-light"
					@click="isRemoveDeviceVisible = false">
					{{ $t('Cancel') }}
				</button>
				<button
					type="button"
					class="btn btn-primary"
					:class="{ 'is-loading': isRemovingDevice }"
					@click="removeDevice">
					{{ $t('Yes') }}
				</button>
			</div>
		</modal>

		<!-- Change Email -->
		<modal
			class="change-email-modal"
			size="medium"
			@close="hideModalChangeEmail"
			v-if="isShowChangeEmail">
			<div slot="header">
				<h3>{{ $t('profile.changeEmail') }}</h3>
			</div>
			<template slot="body">
				<div>
					<div class="profile-field form-group">
						<label for="profile-email"><b>{{ $t('profile.newEmail') }}</b></label>
						<input type="email" class="input form-control" :class="{ 'is-invalid': errorMessages.email }" id="profile-email" placeholder="Your Email Address" @input="emailValidation" v-model="userEmail" :disabled="isHasFeature(user, 'official_seller')">
						<small v-if="errorMessages.email" class="invalid-feedback">Email Tidak Valid</small>
					</div>
					<div class="otp-field" v-if="isShowOtpEmail">
						<otp-field
							type="update_email"
							title=""
							:auto-start-timer="true"
							:generate="isShowOtpEmail"
							v-model="emailOtpCode"
						/>
					</div>
				</div>

			</template>
			<template slot="footer">
				<!-- Cancel -->
				<button
					type="button"
					class="btn btn-light"
					@click="hideModalChangeEmail">
					{{ $t('Cancel') }}
				</button>
				<!-- OTP -->
				<button
					v-if="!isShowOtpEmail"
					type="button"
					class="btn btn-primary"
					:disabled="!isValidEmailFormat"
					@click="isShowOtpEmail=true">
					{{ $t('profile.changeEmail') }}
				</button>
				<!-- Submit -->
				<button
					v-if="isShowOtpEmail"
					class="btn btn-primary"
					:class="{ 'is-loading': isChangingEmail }"
					:disabled="isChangingEmail || (!isValidEmailFormat || !isValidOtpFormat('email'))"
					@click="updateEmail()">
					<span>{{ $t('profile.submit') }}</span>
				</button>
				<!-- Submit -->
			</template>
		</modal>

		<!-- Change Phone Number -->
		<modal
			class="change-phone-number-modal"
			size="medium"
			@close="hideModalChangePhoneNumber"
			v-if="isShowChangePhoneNumber">
			<div slot="header">
				<h3>{{ $t('profile.changePhoneNumber') }}</h3>
			</div>
			<template slot="body">
				<div>
					<div class="profile-field form-group" v-if="isOwner">
						<label for="profile-phone"><b>{{ $t('_.phoneNumber') }}</b></label>
						<div class="input-group">
							<div class="input-group-prepend">
								<span class="input-group-text">{{ countryCode }}</span>
							</div>
							<input type="text" name="phone" class="form-control"
								:class="{ 'is-invalid': errorMessages.phone }"
								placeholder=""
								v-model.trim="userPhone"
								@input="phoneValidation" minlength="9" required>
							<small v-if="errorMessages.phone" class="invalid-feedback">{{ errorMessages.phone }}</small>
						</div>
					</div>
					<div class="otp-field" v-if="isShowOtpPhone">
						<otp-field
							type="update_phone_number"
							title=""
							:auto-start-timer="true"
							:generate="isShowOtpPhone"
							v-model="phoneOtpCode"
						/>
					</div>
				</div>

			</template>
			<template slot="footer">
				<!-- Cancel -->
				<button
					type="button"
					class="btn btn-light"
					@click="hideModalChangePhoneNumber">
					{{ $t('Cancel') }}
				</button>
				<!-- OTP -->
				<button
					v-if="!isShowOtpPhone"
					type="button"
					class="btn btn-primary"
					:disabled="isPhoneNumberError"
					@click="isShowOtpPhone=true">
					{{ $t('profile.changePhoneNumber') }}
				</button>
				<!-- Submit -->
				<button
					v-if="isShowOtpPhone"
					class="btn btn-primary"
					:class="{ 'is-loading': isChangingPhoneNumber }"
					:disabled="isChangingPhoneNumber || (isPhoneNumberError || !isValidOtpFormat('phone'))"
					@click="updatePhoneNumber()">
					<span>{{ $t('profile.submit') }}</span>
				</button>
				<!-- Submit -->
			</template>
		</modal>

		<!-- Bank -->
		<bank-accounts-modal-with-otp
			:show="isShowAddBank"
			@close="isShowAddBank = false">
		</bank-accounts-modal-with-otp>
	</div>

	<notifications group="profile" position="bottom right" />
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import UserDevice from '@/components/UserDevice.vue';
import BankAccounts from '@/components/BankAccounts.vue';
import BankAccountsModalWithOtp from '@/components/BankAccountsModalWithOtp.vue';
import StoreAddress from '@/components/profiles/StoreAddress.vue';
import OtpField from '@/components/forms/OtpField.vue';
import userApi from '@/api/user';
import mediaApi from '@/api/media';
import devicesApi from '@/api/devices';
import { safeTagsReplace, duplicateVar, getPlanLabel, isHasFeature, sensorEmailAddress, generateTimerLabel, getAxiosErrorMessage } from '@/lib/helper';

export default {
	name: 'profile',
	components: {
		Modal,
		UserDevice,
		BankAccounts,
		BankAccountsModalWithOtp,
		StoreAddress,
		OtpField,
	},
	data() {
		return {
			userEdit: {},
			image: false,
			isSaving: false,
			isUploading: false,
			isNameError: false,
			isUsernameError: false,
			isEmailError: false,
			isPhoneNumberError: false,
			isShowChangePassword: false,
			currentPassword: '',
			newPassword: '',
			newPasswordConfirmation: '',
			isChangingPassword: false,
			isNewPasswordValid: true,
			tab: 'profile',
			devices: [],
			isFetchingDevices: false,
			userDevice: null,
			isRemoveDeviceVisible: false,
			isRemovingDevice: false,
			isShowAddBank: false,
			isShowChangePhoneNumber: false,
			isChangingPhoneNumber: false,
			userPhone: '',
			phoneOtpCode: '',
			isShowChangeEmail: false,
			isChangingEmail: false,
			userEmail: '',
			emailOtpCode: '',
			isShowOtpEmail: false,
			isShowOtpPhone: false,
			countryCode: '+62',
			errorMessages: {
				email: '',
				phone: '',
			},
		};
	},
	methods: {
		...mapActions({
			setUser: 'setUser',
			fetchUser: 'fetchUser',
		}),
		duplicateUser() {
			this.userEdit = Object.assign({}, this.user);
			if (!this.userEdit.locale) {
				this.userEdit.locale = 'en';
			}
		},
		saveProfile() {
			this.isSaving = true;
			const user = Object.assign({}, this.userEdit);
			const callback = (response) => {
				const updatedUser = response.data;
				if (!updatedUser.locale) {
					updatedUser.locale = 'en';
				}
				this.setUser(updatedUser);
				this.isSaving = false;
				this.$notify({
					group: 'profile',
					title: 'Profile',
					text: 'Successfully Updated',
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				this.isSaving = false;
			};
			userApi.updateProfile(user, callback, errorCallback);
		},
		onImageChange(event) {
			this.isUploading = true;
			const input = event.target;
			if (input.files && input.files[0]) {
				const image = input.files[0];

				// Preview
				const reader = new FileReader();
				reader.onload = (e) => {
					this.image = e.target.result;
				};
				reader.readAsDataURL(image);

				// Start Upload
				const uploadParams = new FormData();
				uploadParams.append('image', image);

				const callback = (response) => {
					const path = response.data;
					const url = `${this.mediaUrlPrefix}/${path}`;
					this.userEdit.picture = url;
					this.isUploading = false;
					this.image = url;
				};

				const errorCallback = (e) => {
					// eslint-disable-next-line
					console.log(e);
				};

				// Upload Image
				mediaApi.uploadImage(uploadParams, callback, errorCallback);
			}
			event.target.value = null;
		},
		checkUsername() {
			const username = this.userEdit.username;
			if (username && username.length > 2 && this.isValidSubdomain(username)) {
				const callback = () => {
					this.isUsernameError = false;
				};
				const errorCallback = () => {
					this.isUsernameError = true;
				};
				userApi.checkUsername(username, callback, errorCallback);
			} else {
				this.isUsernameError = true;
			}
		},
		usernameParser(username) {
			return username.replace(/[^a-z0-9]/gi, '').trim();
		},
		onUsernameChange() {
			this.userEdit.username = this.usernameParser(this.userEdit.username);
			this.ooDelay(() => {
				this.checkUsername();
			}, 400);
		},
		onNameChange(e) {
			const value = e.target.value;
			const safeValue = safeTagsReplace(value, '');
			this.$set(this.userEdit, 'name', safeValue);
			if (this.userEdit.name === '') {
				this.isNameError = true;
			} else {
				this.isNameError = false;
			}
		},
		onEmailChange() {
			// const isEmailEmtpy = this.userEdit.email === '';
			const isEmailValid = this.isValidEmailFormat;
			if (!isEmailValid) {
				this.isEmailError = true;
				this.errorMessages.email = 'Email tidak valid';
			} else {
				this.isEmailError = false;
				this.errorMessages.email = '';
			}
		},
		onPhoneNumberChange(e) {
			const value = e.target.value;
			if (this.userEdit.phone === '') {
				this.isPhoneNumberError = true;
			} else {
				const safeValue = safeTagsReplace(value, '');
				this.$set(this.userEdit, 'phone', safeValue);
				this.isPhoneNumberError = false;
			}
		},
		onNewPasswordChange() {
			if (this.newPassword === '' || this.newPassword.length < 6) {
				this.isNewPasswordValid = false;
			} else {
				this.isNewPasswordValid = true;
			}
		},
		clearPasswordForm() {
			this.currentPassword = '';
			this.newPassword = '';
			this.newPasswordConfirmation = '';
		},
		changePassword() {
			if (this.hideCurrentPasswordForm) {
				this.currentPassword = this.newPassword;
			}
			const callback = (response) => {
				this.isShowChangePassword = false;
				this.$notify({
					group: 'profile',
					title: 'Profile',
					text: response.message,
					type: 'success',
				});
				this.clearPasswordForm();
				this.fetchUser();
			};
			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'profile',
						title: 'Profile',
						text: errorMessage,
						type: 'error',
					});
				}
			};
			userApi.changePassword(this.currentPassword, this.newPassword, callback, errorCallback);
		},
		setTab(tab) {
			this.tab = tab;
			const query = {
				tab,
			};
			const params = { query };
			this.$router.push(params);
		},
		fetchDevices() {
			this.isFetchingDevices = true;
			const params = {
				sort_by: 'last_active',
				sort: 'desc',
			};
			const callback = (response) => {
				const devices = response.data;
				this.devices = devices;
				this.isFetchingDevices = false;
			};
			const errorCallback = () => {
				this.isFetchingDevices = false;
			};
			devicesApi.getList(params, callback, errorCallback);
		},
		confirmRemove(userDevice) {
			this.userDevice = duplicateVar(userDevice);
			this.isRemoveDeviceVisible = true;
		},
		removeDevice() {
			this.isRemovingDevice = true;
			const id = this.userDevice._id;
			const callback = () => {
				this.onDeviceRemoved(id);
				this.isRemovingDevice = false;
				this.isRemoveDeviceVisible = false;
			};
			const errorCallback = () => {
				this.isRemovingDevice = false;
			};
			devicesApi.delete(id, callback, errorCallback);
		},
		onDeviceRemoved(deviceId) {
			const index = this.devices.findIndex(({ _id }) => _id === deviceId);
			if (index !== -1) {
				this.devices.splice(index, 1);
			}
		},
		isHasFeature,
		showModalChangePhoneNumber() {
			this.isShowChangePhoneNumber = true;
			// this.generateOtp('update_phone_number');
		},
		hideModalChangePhoneNumber() {
			this.isShowChangePhoneNumber = false;
			this.isShowOtpPhone = false;
			this.userPhone = '';
			this.phoneOtpCode = '';
		},
		showModalChangeEmail() {
			this.isShowChangeEmail = true;
			// this.generateOtp('update_email');
		},
		hideModalChangeEmail() {
			this.isShowChangeEmail = false;
			this.isShowOtpEmail = false;
			this.userEmail = '';
			this.emailOtpCode = '';
		},
		updateEmail() {
			this.isChangingEmail = true;

			const params = {
				email: this.userEmail,
				code: this.emailOtpCode,
			};

			const callback = (response) => {
				const updatedUser = response.data;
				if (!updatedUser.locale) {
					updatedUser.locale = 'en';
				}
				this.setUser(updatedUser);
				this.isChangingEmail = false;
				this.isShowOtpEmail = false;
				this.hideModalChangeEmail();
				this.$notify({
					group: 'app',
					title: 'Email',
					text: 'Successfully Updated',
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					title: 'Email',
					text: message ?? 'Failed to update email',
					type: 'error',
				});
				this.isChangingEmail = false;
			};
			userApi.updateEmailWithOTP(params, callback, errorCallback);
		},
		updatePhoneNumber() {
			this.isChangingPhoneNumber = true;

			const params = {
				phone: this.userPhone,
				code: this.phoneOtpCode,
			};

			const callback = (response) => {
				const updatedUser = response.data;
				if (!updatedUser.locale) {
					updatedUser.locale = 'en';
				}
				this.setUser(updatedUser);
				this.isChangingPhoneNumber = false;
				this.isShowOtpPhone = false;
				this.hideModalChangePhoneNumber();
				this.$notify({
					group: 'app',
					title: 'Phone Number',
					text: 'Successfully Updated',
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					title: 'Phone Number',
					text: message ?? 'Failed to update phone number',
					type: 'error',
				});
				this.isChangingPhoneNumber = false;
			};
			userApi.updatePhoneNumberWithOTP(params, callback, errorCallback);
		},
		phoneValidation() {
			const validPhone = this.userPhone.trim() !== '' && !new RegExp(/^\+\d+$/).test(this.userPhone.trim());
			this.userPhone = this.userPhone.replace(/[^\d]/g, '');
			if (validPhone) {
				const firstSelection = this.userPhone.substring(0, 1);
				const secondSelection = this.userPhone.substring(0, 2);
				let phone = this.userPhone;
				if (secondSelection === '62') {
					phone = phone.replace('62', '');
				} else if (firstSelection === '0') {
					phone = phone.replace('0', '');
				}
				this.userPhone = phone;
				if (this.userPhone.length < 9) {
					this.errorMessages.phone = 'Nomor Telepon Minimal 9 Digit';
				} else {
					this.errorMessages.phone = '';
				}
			} else {
				this.errorMessages.phone = 'Nomor Telepon Tidak Valid';
			}
		},
		emailValidation() {
			const isEmailValid = this.isValidEmailFormat;
			if (!isEmailValid) {
				this.errorMessages.email = 'Email tidak valid';
			} else {
				this.errorMessages.email = '';
			}
		},
		isValidOtpFormat(type = 'email') {
			let isValidOtpFormat = false;

			if (type === 'email') {
				isValidOtpFormat = this.emailOtpCode.toString().length === 6;
			} else if (type === 'phone') {
				isValidOtpFormat = this.phoneOtpCode.toString().length === 6;
			}

			return isValidOtpFormat;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			isSupplier: 'isSupplier',
			isDropshipper: 'isDropshipper',
			bankAccounts: 'bankAccounts',
			isPasswordEmpty: 'isPasswordEmpty',
			isAuthWithOO: 'isAuthWithOO',
			isExpired: 'isExpired',
		}),
		imageDisplay() {
			return this.image ? this.image : this.userEdit.picture;
		},
		isHasError() {
			return this.isUsernameError || this.isNameError || this.isEmailError || this.isPhoneNumberError;
		},
		isNewPasswordMatch() {
			return this.newPassword === this.newPasswordConfirmation;
		},
		isCanChangePassword() {
			return this.isNewPasswordValid && this.isNewPasswordMatch;
		},
		productLimit() {
			const isNotUnlimited = this.user && this.user.credit.product_creation !== -1;
			return isNotUnlimited ? this.formatNumberPlain(this.user.credit.product_creation) : 'Unlimited';
		},
		orderLimit() {
			const isNotUnlimited = this.user && this.user.credit.order !== -1;
			return isNotUnlimited ? this.formatNumberPlain(this.user.credit.order) : 'Unlimited';
		},
		teamMemberLimit() {
			const isNotUnlimited = this.user && this.user.credit.team_member !== -1;
			return isNotUnlimited ? this.formatNumberPlain(this.user.credit.team_member) : 'Unlimited';
		},
		expiredDate() {
			const expiredDate = this.moment(this.user.expired_date);
			// Check if the expired date is more than one year from now
			const years = expiredDate.diff(this.moment(), 'years');
			let display = expiredDate.format('DD-MM-YYYY');
			if (years > 50) {
				display = 'Lifetime';
			}
			return display;
		},
		subscriptionStartDate() {
			if (!this.user || !this.user.expired_date) return '-';
			const expiredDate = this.moment(this.user.expired_date);
			const years = expiredDate.diff(this.moment(), 'years');
			if (years > 50) {
				return this.user.created_at ? this.moment(this.user.created_at).format('DD MMM YYYY') : '-';
			}
			return expiredDate.subtract(30, 'days').format('DD MMM YYYY');
		},
		subscriptionEndDate() {
			if (!this.user || !this.user.expired_date) return '-';
			const expiredDate = this.moment(this.user.expired_date);
			const years = expiredDate.diff(this.moment(), 'years');
			if (years > 50) {
				return 'Lifetime';
			}
			return expiredDate.format('DD MMM YYYY');
		},
		isOwner() {
			return this.user && this.user.role === 'owner';
		},
		tabQuery() {
			return this.$route.query.tab;
		},
		planLabel() {
			const plan = this.user.package;
			return getPlanLabel(plan);
		},
		sensoredEmail() {
			const email = this?.user?.email ?? '';
			const sensoredEmail = this.isOwner ? sensorEmailAddress(email) : 'Owner account ini';
			return sensoredEmail;
		},
		otpTimer() {
			const timerLabel = generateTimerLabel(this.otpTimerValue);
			return timerLabel;
		},
		hideCurrentPasswordForm() {
			return this.isPasswordEmpty && this.isAuthWithOO;
		},
		isValidEmailFormat() {
			const isValidEmailFormat = String(this.userEmail.trim()).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
			return isValidEmailFormat;
		},
	},
	created() {
		if (this.user) {
			this.duplicateUser();
			if (this.user.username === '') {
				this.checkUsername();
			}
			if (this.user.phone === '' || this.userEdit.phone === '') {
				this.isPhoneNumberError = true;
			}
			// if (!this.isOwner) {
			// 	this.tab = 'profile';
			// }
		}
		if (this.tabQuery) {
			this.tab = this.tabQuery;
		}
	},
	watch: {
		user(user) {
			if (user) {
				this.duplicateUser();
				if (!this.isOwner) {
					this.tab = 'profile';
				}
			}
		},
		tab(tab) {
			if (tab === 'devices') {
				this.fetchDevices();
			}
		},
	},
};
</script>
